<script lang="ts" setup>
import { inject } from 'vue';
import { type DataTableSort, useDataTable, type DataTableColumn as ColumnModel } from '../../';
import DataTableTableColumn from './table-view/DataTableTableColumn.vue';

import DataTableTableViewModeRow from './DataTableTableViewModeRow.vue';

const dataTableService = inject<ReturnType<typeof useDataTable>>('dataTableService')!;
const emit = defineEmits(['rowAction', 'sort']);

const onSort = (sort: DataTableSort | null) => {
  emit('sort', sort);
};

const isColumnHidden = (column: ColumnModel) => {
  if (column.condition !== undefined) {
    return !column.condition();
  }

  return false;
};

const onRowAction = (action: string, item: any, data?: any) => {
  emit('rowAction', action, item, data);
};
</script>

<template>
  <v-table
    class="data-table-view data-table-view--table"
    :fixed-header="dataTableService.getConfig.value.fixedHeader"
    :fixed-footer="dataTableService.getConfig.value.fixedFooter"
    :height="dataTableService.getConfig.value.height"
    :hover="dataTableService.getConfig.value.hover">
    <thead v-if="dataTableService.getConfig.value.needTableHeader">
      <tr>
        <template
          v-for="(column, i) in dataTableService.getColumns.value"
          :key="column.name + i">
          <data-table-table-column
            v-if="column.visible && !isColumnHidden(column)"
            :column="column"
            @sort="onSort" />
        </template>
      </tr>
    </thead>
    <tbody>
      <template
        v-for="(item, i) in dataTableService.getItems.value"
        :key="i">
        <data-table-table-view-mode-row
          :item="item"
          :i="i"
          @row-action="onRowAction" />
      </template>
    </tbody>
  </v-table>
</template>
